import React from 'react';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-gradient-to-b from-blue-900 to-blue-800 text-white overflow-hidden" data-id="element-36">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-37"></div>

      <div className="max-w-6xl mx-auto px-4 py-16 md:py-24 relative z-10" data-id="element-38">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-39">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left" data-id="element-40">
            <div className="inline-block bg-orange-500 text-white text-xs md:text-sm font-bold px-3 py-1 rounded-full mb-6 uppercase tracking-wide shadow-lg" data-id="element-41">
              Para docentes de nivel secundario
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 text-white drop-shadow-md" data-id="element-42">
              SIC 360
            </h1>

            <p className="text-xl md:text-2xl text-blue-100 mb-8 leading-relaxed max-w-2xl" data-id="element-43">
              Todo el año de Contabilidad resuelto para enseñar con claridad,
              seguridad y sentido real sin planificar nada desde cero.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-44">
              <button onClick={scrollToPurchase} className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-8 rounded-lg shadow-lg transform transition hover:-translate-y-1 text-lg flex items-center justify-center gap-2" data-id="element-45">
                DESCUBRIR SIC 360
                <ArrowDown className="w-5 h-5" data-id="element-46" />
              </button>
            </div>
          </div>

          {/* Hero Image */}
          <div className="flex-1 w-full max-w-md md:max-w-lg" data-id="element-47">
            <div className="relative" data-id="element-48">
              <div className="absolute inset-0 bg-blue-500 blur-3xl opacity-20 rounded-full" data-id="element-49"></div>
              <img src="https://cdn.magicpatterns.com/uploads/gunfaKVhNx6PqAaQ9BdF5v/Cover_SIC_360.png" alt="SIC 360 - Clases Anuales Resueltas" className="relative z-10 w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-50" />
            </div>
          </div>
        </div>
      </div>

      {/* Wave Divider */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-51">
        <svg className="relative block w-[calc(100%+1.3px)] h-[50px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-52">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-white" data-id="element-53"></path>
        </svg>
      </div>
    </section>;
}